/**
 * @Author: xiaodongyu
 * @Date: 2023-10-30 16:16:29
 * @Last Modified by: xiaodongyu
 * @Last Modified time: 2023-10-30 16:19:44
 */
/* eslint-disable no-underscore-dangle */
__webpack_public_path__ = window.__webpack_public_path__ || __PUBLIC_PATH__;
